<template>
  <ten-popup
    v-bind="$attrs"
    v-on="$listeners"
    type="bubble"
    :direction="direction"
    :trigger-type="triggerType"
    :width="width"
    :popup-class="_popupClass"
  >
    <div class="ten-tooltip-content">
      <div class="ten-tooltip__message">
        <slot name="message">
          {{ message }}
        </slot>
      </div>
      <div
        class="ten-tooltip__extra"
        v-if="hasExtra"
      >
        <!-- @slot 额外内容，比如底部链接 -->
        <slot name="extra" />
      </div>
    </div>
    <template v-slot:trigger>
      <slot />
    </template>
  </ten-popup>
</template>

<script>
import TenPopup from '../popup';
const name = 'ten-tooltip';

export default {
  name,
  components: { TenPopup },
  inheritAttrs: false,
  props: {
    /**
     * 暗色模式
     */
    dark: Boolean,
    /**
     * @ignore
     */
    direction: {
      type: String,
      default: 'top center',
    },
    /**
     * 提示文本
     */
    message: String,
    /**
     * @ignore
     */
    width: [Number, Function],
    /**
     * @ignore
     */
    popupClass: [String, Object, Array],
    /**
     * @ignore
     */
    triggerType: {
      validator: val => ['click', 'hover', 'manual'].indexOf(val) > -1,
      default: 'hover',
    },
  },
  data() {
    return {
      hasExtra: false,
    };
  },
  computed: {
    _popupClass() {
      return [
        name,
        { 'ten-tooltip--dark': this.dark },
        this.popupClass,
      ];
    },
  },
  mounted() {
    this.hasExtra = !!this.$scopedSlots.extra;
  },
};
</script>
